export enum ModelsNames {
  Areas = 'areas',
  Automations = 'automations',
  Drivers = 'drivers',
  Passengers = 'passengers',
  RefreshTokens = 'refresh_tokens',
  Verticals = 'verticals',
  Roles = 'roles',
  Moderators = 'moderators',
  Companies = 'companies',
  Sites = 'sites',
  Vehicles = 'vehicles',
  GeoLocation = 'geo_locations',
  Locations = 'locations',
  Suppliers = 'suppliers',
  ExtraService = 'extraServices',
  Reservations = 'reservations',
  Service = 'services',
  Trips = 'trips',
  Profiles = 'profiles',
  Shifts = 'shifts',
  FareGroup = 'fare_groups',
  RateGroup = 'rate_groups',
  DriverShifts = 'driver-shifts',
  Fares = 'fares',
  Productions = 'productions',
  Settings = 'settings',
  Payments = 'payments',
  Rates = 'rates',
  Attributes = 'attributes',
  Shuttles = 'shuttles',
  ShuttleGroups = 'shuttle_groups',
  SecretKeys = 'secret_keys',
  IdCounters = 'id_counters',
  Webhooks = 'webhooks',
  History = 'history',
  BlacklistCard = 'blacklist_cards',
  DriverLocations = 'driver_locations',
  DataUpload = 'data_uploads',
  CustomRules = 'customRules',
  Integrations = 'integrations',
  Themes = 'themes',
  Timeline = 'timeline',
}

export type DataUploadModels =
  | ModelsNames.Areas
  | ModelsNames.Drivers
  | ModelsNames.Vehicles
  | ModelsNames.ExtraService
  | ModelsNames.Service
  | ModelsNames.Attributes
  | ModelsNames.Locations
  | ModelsNames.Fares
  | ModelsNames.Rates
  | ModelsNames.Profiles
  | ModelsNames.Passengers
  | ModelsNames.Suppliers
  | ModelsNames.Shuttles
  | ModelsNames.Shifts
  | ModelsNames.DriverShifts
  | ModelsNames.BlacklistCard
  | ModelsNames.Reservations
  | ModelsNames.CustomRules;
